import React, { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';
import { withRouter } from "react-router";
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, CircularProgress } from '@material-ui/core';
import { Pagination, STableLoader, PageLoader, EmptyCollection, DeletePopUp } from "../../../shared_elements";
import { Skeleton } from '@material-ui/lab';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { globalDeleteService, globalGetService, globalPostService, globalPutService } from "../../../globalServices";
import { checkApiStatus, convertStringToNumber, onCheckFormPermission } from '../../../utils_v2';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import MomentUtils from "@date-io/moment";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import { backendDateFormat, displayDateTimeFormat, fieldDateFormat } from "../../../constants";
import CertificateImport from "./CertificateImport";
const certificatesObj = {
    name: '',
    issue_date: '',
    expiry_date: null,
    remarks: ''
}
const CertificatesHd = ({ currentFormDetail }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>Certificate Name</TableCell>
                <TableCell>Issue Date</TableCell>
                <TableCell>Expiry Date</TableCell>
                <TableCell>Remarks</TableCell>
                {onCheckFormPermission(currentFormDetail) ? <TableCell align='right'>Action(s)</TableCell> : null}
            </TableRow>
        </TableHead>
    )
}
const CertificatesList = ({ item, onEdit, onDelete, currentFormDetail }) => {
    const [showMore, setShowMore] = useState({});
    const toggleDescription = (field) => {
        setShowMore({
            ...showMore,
            [field]: !showMore[field],
        });
    };
    return (
        <TableRow>
            <TableCell><div style={{ width: '200px' }} >{item?.name}</div></TableCell>
            <TableCell><div style={{ width: '150px' }} >{item?.issue_date ? moment(item?.issue_date).format(displayDateTimeFormat) : '--'}</div></TableCell>
            <TableCell><div style={{ width: '150px' }} >{item?.expiry_date ? moment(item?.expiry_date).format(displayDateTimeFormat) : '--'}</div></TableCell>
            <TableCell>
                {item?.remarks && item.remarks.length > 30 ? (
                    <div style={{ width: '300px' }}>
                        {showMore[item.field] ? (
                            <>
                                <span dangerouslySetInnerHTML={{ __html: item.remarks.replace(/\n/g, '<br />'), }} />
                                <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {' '}less </a>
                            </>
                        ) : (
                            <>
                                <span dangerouslySetInnerHTML={{ __html: item.remarks.substring(0, 25).replace(/\n/g, '<br />'), }} />
                                <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {' '}..more </a>
                            </>
                        )}
                    </div>
                ) : (
                    <div style={{ width: '140px' }} dangerouslySetInnerHTML={{ __html: item?.remarks ? item.remarks.replace(/\n/g, '<br />') : '--', }} />
                )}
            </TableCell>
            {onCheckFormPermission(currentFormDetail) ?
                <TableCell align='right'>
                    <ul className="list-inline" style={{ float: 'right' }}>
                        <li className="list-inline-item hover-inline" onClick={onEdit}>
                            <Tooltip title='Edit' style={{ cursor: 'pointer' }} arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                        </li>
                        <li className="list-inline-item hover-inline" onClick={onDelete}>
                            <Tooltip title='Delete' style={{ cursor: 'pointer' }} arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                        </li>
                    </ul>
                </TableCell> : null
            }
        </TableRow>
    )
}
const AddEditCertifictes = ({ params, addEditCertificates, toggleModalFn, getResponseBack }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [certificates, setAvionic] = useState(addEditCertificates.data);
    const [error, setError] = useState({});
    const onFieldChange = (key, value) => {
        setAvionic({ ...certificates, [key]: value})
    }
    const onAddEditCertificates = () => {
        let validationInputs = {};
        validationInputs = {
            ...validationInputs,
            name: certificates.name ? '' : 'Please enter Name',
            issue_date: certificates.issue_date ? '' : 'Please enter Issue Date' 
        }
        if (certificates.issue_date && !moment(certificates.issue_date).isValid()) {
            validationInputs = {
                ...validationInputs,
                issue_date: 'Enter valid Issue date'
            }
        }  
        if (certificates.issue_date && moment(certificates.issue_date).isAfter(moment())) {
            validationInputs = {
                ...validationInputs,
                issue_date: "Issue date can't future date"
            }
        } 
        if (certificates.expiry_date && !moment(certificates.expiry_date).isValid()) {
            validationInputs = {
                ...validationInputs,
                expiry_date: 'Enter valid Expiry date'
            }
        }
        
        if (moment(certificates.issue_date).isValid() && moment(certificates.expiry_date).isValid()) {
            if (moment(certificates.expiry_date) < moment(certificates.issue_date)) {
                validationInputs = {
                    ...validationInputs,
                    expiry_date: 'Expiry date cannot be lesser than Issue Date'
                }
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            const payload = Object.assign({}, (!certificates.id ? { certificates: [certificates] } : certificates))
            setLoading(true);
            if (certificates.id) {
                globalPutService(`technical/workorder/${params.workOrderSlug}/t014/certificates/${certificates.id}/?type=T014&asset_type=${params.type}`, payload)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            toggleModalFn(); getResponseBack();
                        }
                        setLoading(false);
                    })
            } else {
                globalPostService(`technical/workorder/${params.workOrderSlug}/t014/certificates/?type=T014&asset_type=${params.type}`, payload)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            toggleModalFn(); getResponseBack();
                        }
                        setLoading(false);
                    })
            }
        } else {
            setError(validationInputs)
        }
    }
    const isFieldEmpty = () => {
        if(certificates.id){
            return Object.entries(certificates).filter(([key]) => key !== 'id').some(([_, value]) => value !== '' && value !== null);        
        }else{
            return Object.values(certificates).some(value => value !== '' && value !== null);
        }
    };
    return (
        <Dialog open={addEditCertificates.modal} className='project-management-modal' maxWidth="md" >
            <DialogTitle id="scroll-dialog-title"> {certificates?.id ? 'Edit ' : 'Add '} Certificate </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={1}>
                    <Grid item md={4}>
                        <TextField
                            required
                            name='name'
                            label='Certificate Name'
                            value={certificates?.name || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => {onFieldChange('name', (e.target.value).trimStart());setError({ ...error, 'name': '' }) }}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            inputProps={{ maxLength: 255 }}
                            error={error.name ? true : false}
                            helperText={error.name || ''}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <KeyboardDatePicker
                                required
                                margin="normal"
                                name="issue_date"
                                label="Issue Date"
                                format={fieldDateFormat}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                maxDate={moment()}
                                minDate={moment().subtract(25, 'years')}
                                value={certificates?.issue_date || null}
                                onChange={(data, value) => { onFieldChange('issue_date', data ? moment(data).format(backendDateFormat) : null); setError({ ...error, 'issue_date': '' }) }}
                                inputVariant='outlined'
                                error={error.issue_date ? true : false}
                                helperText={error.issue_date || ''}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item md={4}>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                name="expiry_date"
                                label="Expiry Date"
                                format={fieldDateFormat}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                minDate={moment().subtract(25, 'years')}
                                value={certificates?.expiry_date || null}
                                onChange={(data, value) => { onFieldChange('expiry_date', data ? moment(data).format(backendDateFormat) : null); setError({ ...error, 'expiry_date': '' }) }}
                                inputVariant='outlined'
                                error={error.expiry_date ? true : false}
                                helperText={error.expiry_date || ''}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item md={12}>
                        <TextField
                            name='remarks'
                            label='Remarks'
                            value={certificates?.remarks || ''}
                            fullWidth
                            multiline
                            rows={3}
                            margin="normal"
                            onChange={(e) => onFieldChange('remarks', (e.target.value).trimStart())}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 255 }}
                            variant='outlined'
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button disabled={isLoading || !isFieldEmpty()} onClick={onAddEditCertificates} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
const Certificates = ({ params, getCurrentFormDetail, currentFormDetail }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [certificatesInfo, setCertificatesInfo] = useState({ list: [], pagination: null });
    const [addEditCertificates, setAddEditCertificates] = useState({ modal: false, data: null });
    const [deleteCertificates, setDeleteCertificates] = useState({ modal: false, data: null });
    useEffect(() => {
        getCertificates({}, 'skeletonLoader');
    }, []);
    const getCertificates = (query, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`technical/workorder/${params.workOrderSlug}/t014/certificates/?type=T014&asset_type=${params.type}`,query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setCertificatesInfo(response.data.data)
                    getCurrentFormDetail()
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onDeleteCertificates = () => {
        setLoading(true);
        globalDeleteService(`technical/workorder/${params.workOrderSlug}/t014/certificates/${deleteCertificates.data.id}/?type=T014&asset_type=${params.type}`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteCertificates({ modal: false, data: null });
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    getCertificates({}, 'pageLoader');
                }
                setLoading(false);
            })
    }
    return (
        <>
            <div className="tech-specs-content">
                {skeletonLoader ?
                    <div style={{ padding: '10px' }}>
                        <Paper square style={{ padding: '4px 8px' }}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item md={9}></Grid>
                                <Grid item md={3}>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                        <Skeleton variant="rect" animation='wave' width={130} height={30} style={{ borderRadius: 4 }} />
                                        <Skeleton variant="rect" animation='wave' width={70} height={30} style={{ borderRadius: 4 }} />
                                    </div>
                                </Grid>
                            </Grid>
                        </Paper>
                        <STableLoader count={8} rowsFill={7} />
                    </div> :
                    <div style={{ padding: '10px' }}>
                        <Paper square style={{ padding: '4px 8px' }}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item md={9}></Grid>
                                <Grid item md={3}>
                                    {onCheckFormPermission(currentFormDetail) ?
                                        <ul className="list-inline" style={{ float: 'right' }}>
                                             <li className="list-inline-item">
                                                <CertificateImport getResponseBack={() => getCertificates({})} />
                                            </li>
                                            <li className="list-inline-item">
                                                <Button onClick={() => setAddEditCertificates({ modal: true, data: certificatesObj })} color="primary" size='small' variant="contained"><AddOutlinedIcon style={{ fontSize: '16px' }} />ADD</Button>
                                            </li>
                                        </ul> : null
                                    }
                                </Grid>
                            </Grid>
                        </Paper>
                        <Paper style={{ maxHeight: window.innerHeight - 235 + 'px', overflow: "auto" }}>
                            <Table className='mui-table-format' stickyHeader>
                                <CertificatesHd currentFormDetail={currentFormDetail} />
                                <TableBody>
                                    {certificatesInfo.list?.map((item, index) =>
                                        <CertificatesList
                                            key={index}
                                            item={item}
                                            currentFormDetail={currentFormDetail}
                                            onEdit={() => setAddEditCertificates({ modal: true, data: item })}
                                            onDelete={() => setDeleteCertificates({ modal: true, data: item })}
                                        />
                                    )}
                                </TableBody>
                            </Table>
                        </Paper>
                        {certificatesInfo?.pagination ?
                            <Paper>
                                <Pagination
                                    pagination={certificatesInfo.pagination}
                                    onChangePage={(event, newPage) => getCertificates({ ...filter, page: newPage + 1, per_page: certificatesInfo.pagination.per_page }, 'pageLoader')}
                                    onChangeRowsPerPage={(event) => getCertificates({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                                />
                            </Paper>
                            : null
                        }
                        <Paper>
                            {!certificatesInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </Paper>
                    </div>
                }
            </div>
            {addEditCertificates.modal ?
                <AddEditCertifictes
                    params={params}
                    addEditCertificates={addEditCertificates}
                    toggleModalFn={() => setAddEditCertificates({ modal: false, data: null })}
                    getResponseBack={() => getCertificates({}, 'pageLoader')}
                /> : null
            }
            {deleteCertificates.modal ?
                <DeletePopUp
                    modal={deleteCertificates.modal}
                    title='Delete Certificate'
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteCertificates({ modal: false, data: null })}
                    deleteRecordFn={onDeleteCertificates}
                /> : null
            }
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default withRouter(Certificates);